import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ViewCell} from 'ng2-smart-table';
@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent  implements ViewCell{

    constructor(){}

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() action = new EventEmitter();

    onClick(action) {
        this.action.emit({action:action, element:this.rowData});

    }
}





// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/smart-table/action-buttons/action-buttons.component.ts